import React from "react";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import { DataTableSkeleton } from "frontend/src/ui/data-table-skeleton";
export var PageSkeleton = function () { return (React.createElement(Box, null,
    React.createElement(Skeleton, { variant: "rect", height: 124 }),
    React.createElement(Box, { mt: 2 },
        React.createElement(DataTableSkeleton, null)))); };
